export default __webpack_public_path__ + "static/media/arrow-down.e2a65a1a.svg";